import { FormControlLabel, MobileStepper, Radio } from '@mui/material';
import { styled } from '@mui/material/styles';

import { VAR_AREA_TOP } from '@mopla/constants';
import { Recaptcha } from '@mopla/ui';

export const DrawerContentWrapper = styled('div')(() => ({
	height: '100%',
	overflow: 'auto',
}));

export const LoaderWrapper = styled('div')(() => ({
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
	height: '100%',
}));
export const ContentWrapper = styled('div')(({ theme }) => ({
	display: 'grid',
	gridGap: 16,
	margin: '8px',
	padding: '24px 16px',
	background: theme.palette.neutral[0],
	borderRadius: 8,
	overflow: 'auto',
}));
export const ThirdStepWrapper = styled('div')(() => ({
	marginTop: 8,

	'& > div': {
		margin: 0,
		padding: 0,
	},
}));
export const Wrapper = styled('div')(() => ({
	display: 'grid',
	gridGap: 16,
}));

export const CustomStepper = styled(MobileStepper)(({ theme }) => ({
	background: 'transparent',
	justifyContent: 'center',
	'.MuiMobileStepper-dotActive': {
		backgroundColor: theme.palette.primary.main,
	},
}));

export const StyledFormControlLabel = styled(FormControlLabel)(() => ({
	marginLeft: 0,
	marginBottom: 10,
	'>span:last-of-type': {
		fontSize: 18,
	},
}));
export const StyledRadio = styled(Radio)(() => ({
	margin: '0 10px 0',
	padding: 0,
}));

export const ScrollableWrapper = styled('div')(() => ({
	overflow: 'auto',
	height: '100%',
}));

export const ConfirmationWrapper = styled('div')(({ theme }) => ({
	display: 'grid',
	gap: 24,
	gridAutoRows: 'max-content',
	padding: '0 24px 16px',
	[theme.breakpoints.up('tabletP')]: {
		padding: '16px 24px',
		background: theme.palette.primary.main,
	},
}));

export const StyledRecaptcha = styled(Recaptcha)(({ theme }) => ({
	'& .grecaptcha-badge': {
		bottom: 'unset !important',

		[theme.breakpoints.up('tabletP')]: {
			top: 80,
		},

		[theme.breakpoints.down('tabletP')]: {
			top: `calc(72px + ${VAR_AREA_TOP})`,
		},
	},
}));
